.container {
  display: flex;
  flex-direction: row;
  border: 1px solid var(--color-divider);
  border-radius: 8px;
  overflow: hidden;
}
